// extracted by mini-css-extract-plugin
export var activeObjective = "header-module--activeObjective--3223e";
export var closeButton = "header-module--closeButton--756ad";
export var header = "header-module--header--666b3";
export var menuBtn = "header-module--menuBtn--c3c97";
export var menuClosed = "header-module--menuClosed--0840e";
export var menuOpen = "header-module--menuOpen--53b97";
export var mobileContainer = "header-module--mobileContainer--b2c57";
export var mobileHeading = "header-module--mobileHeading--54b89";
export var mobileOverlay = "header-module--mobileOverlay--2ccb1";
export var nav = "header-module--nav--7bc38";
export var objectiveContainer = "header-module--objectiveContainer--1aa41";
export var objectiveLink = "header-module--objectiveLink--41419";
export var overlay = "header-module--overlay--5a5c6";
export var subHeadingContainer = "header-module--subHeadingContainer--625a7";
export var title = "header-module--title--de67b";